module.exports = __webpack_public_path__ + "static/media/otter-over-de-grens-interreg-vn-vertical.f2ab60a2.png";